import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntBadgeComponent} from "./int-badge.component";
import {BaseBadgeModule} from "../../../shared";

@NgModule({
  imports: [
    CommonModule,
    BaseBadgeModule
  ],
  declarations: [
    IntBadgeComponent
  ],
  exports: [
    IntBadgeComponent
  ]
})
export class IntBadgeModule {}
